export const STORAGE_KEYS = {
  EPIC_ADMIN_ACCESS_TOKEN: 'epic_admin_access_token',
  EPIC_ADMIN_REFRESH_TOKEN: 'epic_admin_refresh_token',
  EPIC_ADMIN_CURRENT_USER: 'epic_admin_current_user',
  EPIC_ORDERING: 'epic_ordering',
}
